import { Button, Card, CardContent, CardHeader, Grid, List, ListItem, ListItemIcon, ListItemText, Toolbar, Typography, makeStyles } from '@material-ui/core';
import { MapBox } from 'components/AddressLocationForm/MapBox';
import useCustomModal from 'components/CustomConfirm';
import CustomConfirmDialog from 'components/CustomConfirm/CustomConfirmDialog';
import { LocationEdit } from 'pages/CustomerBooking/LocationConfirmation/LocationEdit';
import { localPackageCalculate } from 'pages/CustomerBookingCreate/Cart';
import { PageHeader } from 'pages/CustomerBookingCreate/components/PageHeader';
import { START_STEP, STEP_LOCATION, STEP_PERSONAL_DETAILS, STEP_RECIPIENT, STEP_SCHEDULE, STEP_SERVICE_BREAKDOWN, STEP_SIGN_IN } from 'pages/CustomerBookingCreate/constants';
import { bookingState, cartEmptyState, confirmChangeLocationState, isCartPrefilledState, packagesState, servicesState, sessionTokenState, skipStepState, stepState } from 'pages/CustomerBookingCreate/state';
import { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { anonSessionToken } from 'services/anon.service';
import { isAuthenticated, useUserState } from 'services/authentication.service';
import locationsService from 'services/locations.service';
import { fingerprintState } from 'util/deviceUUID';
import { formatAddressObject } from 'util/format';
import { parseAddressTypeToIcons } from 'util/parseAddressIcons';
import { useTrackEvent } from 'util/trackEvent';
import { ABAltAuthenticatedLocationScreen } from './ABAltAuthenticatedLocationScreen';
import { toasterror } from 'util/toasterror';

const useStyles = makeStyles(theme => ({
  dialog: {
    "z-index": `${theme.zIndex.modal - 1} !important `,
  },
  dialogPaper: {
    [theme.breakpoints.down("sm")]: {
      width: '100%',
    },
    [theme.breakpoints.up("md")]: {
      width: theme.breakpoints.values.sm,
    }
  },
  dialogFullContent: {
    overflowY: 'unset'
  },
  dialogScrollContent: {

  },
  dialogRoot: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    alignContent: "center",
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
  },
  locationList: {
    flex: 1,

    overflowY: 'scroll',
    height: '100%'
  },
  wrapper: {
    whiteSpace: 'normal'
  },
  cardHeaderAction: {
    margin: "auto"
  },
  cardHeaderRoot: {
    padding: theme.spacing(1),
    flexDirection: 'row',
    [theme.breakpoints.down("sm")]: {
      textAlign: 'center',
      flexDirection: 'column',
    }
  },
  cardRoot: {
    height: '50vh',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down("sm")]: {
      height: '100%'
    }
  },

  addressIcon: {
    [theme.breakpoints.down("sm")]: {
      display: 'none',

    }
  },
  secondaryLocation: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  }
}));
const LocationScreen = ({ }) => {
  const classes = useStyles()
  const [step, setStep] = useRecoilState(stepState);
  const [booking, setBooking] = useRecoilState(bookingState);
  const [packages, setPackages] = useRecoilState(packagesState);
  const [services, setServices] = useRecoilState(servicesState);

  const [skipStep, setSkipStep] = useRecoilState(skipStepState);

  const [isCartPrefilled, setIsCartPrefilled] = useRecoilState(isCartPrefilledState);

  const [confirmChangeLocation, setConfirmChangeLocation] = useRecoilState(confirmChangeLocationState);
  const isCartEmpty = useRecoilValue(cartEmptyState);
  const history = useHistory();
  const trackEvent = useTrackEvent()

  const [marker, setMarker] = useState({
    latitude: 14.562909599624389,
    longitude: 121.03317570610837
  });

  const [sessionToken, setSessionToken] = useRecoilState(sessionTokenState);
  const fingerprint = useRecoilValue(fingerprintState)

  const fetchAnonToken = useCallback(
    async () => {
      if (sessionToken) return
      try {
        const token = await anonSessionToken(fingerprint)
        setSessionToken(token?.token)
      } catch (error) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details, { error })
      }
    },
    [fingerprint],
  );

  useEffect(
    () => {
      fetchAnonToken()
    }, [fingerprint]
  );


  const confirm = useCustomModal()

  const matchCity = useCallback(
    async (location) => {
      try {
        const opId = await locationsService.mapLocationToOperationAreaId({
          latitude: location?.latitude,
          longitude: location?.longitude
        })
        return {
          ...location,
          operationAreaId: opId
        }
      } catch (error) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details, { error })
        return location
      }
    },
    [],
  );

  const checkSkipStep = useCallback(
    (s) => {
      if (skipStep) {
        setStep(skipStep)
        setSkipStep(null)
        history.replace(skipStep, { internal: true })
      } else {
        setStep(s)
        history.replace(s, { internal: true })
      }
    },
    [skipStep],
  );



  const checkCartStatus = useCallback(
    async ({ address }) => {
      // if (isCartEmpty || isCartPrefilled) {
      const mappedAddress = await matchCity(address)
      setBooking({
        ...booking,
        location: mappedAddress
      })
      setIsCartPrefilled(false)
      checkSkipStep(STEP_SCHEDULE)
      // } else {
      //   showCartMayChangeDialog({ address })
      // }
    },
    [booking, packages, services],
  );

  return (
    <>
      <PageHeader
        backStep={STEP_PERSONAL_DETAILS}
        currentStep={STEP_LOCATION}
        title={"Where should we deliver the service?"}
        subheader={"Enter your address in the box below or drag the map to your exact location. Use the tab button to proceed through the form."}
        loading={false}
      >
        <div className={classes.card}>
          {sessionToken ? (
            <LocationEdit
              sessionToken={sessionToken}
              affirmLabel={"Continue"}
              altLayout
              // location={booking?.location || marker}
              location={booking?.location?.isDefaultLocation ? null : booking?.location}
              isEditing
              requiresNewLocation
              forceRequireNewLocation
              onSelectConfirm={(a) => {
                console.log('index.jsx (37)onSelectConfirm', a)

              }}
              onSelectExistingConfirm={(a) => {
                console.log('index.jsx (41)onSelectExistingConfirm', a)

              }}
              onSelectEdit={(a) => {
                console.log('index.jsx (45)onSelectEdit', a)

              }}
              onUpdateAddress={(a) => {
                console.log('index.jsx (49)onUpdateAddress', a)
                trackEvent('Create Booking Location Screen - Update Address', { address: a })
                checkCartStatus({ address: a })
              }}
            />
          ) : (
            <>...waiting for token</>
          )}

        </div>

      </PageHeader>

    </>
  )
}

const AuthenticatedLocationScreen = ({ }) => {
  const classes = useStyles()
  const trackEvent = useTrackEvent()
  const [step, setStep] = useRecoilState(stepState);
  const [booking, setBooking] = useRecoilState(bookingState);
  const [loading, setLoading] = useState(false);
  const [packages, setPackages] = useRecoilState(packagesState);
  const [services, setServices] = useRecoilState(servicesState);

  const { getUser } = useUserState()
  const [skipStep, setSkipStep] = useRecoilState(skipStepState);
  const [confirmChangeLocation, setConfirmChangeLocation] = useRecoilState(confirmChangeLocationState);
  const isCartEmpty = useRecoilValue(cartEmptyState);
  const [existingLocations, setExistingLocations] = useState([]);
  const [isCartPrefilled, setIsCartPrefilled] = useRecoilState(isCartPrefilledState);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const mapRef = useRef(null)
  const [marker, setMarker] = useState({
    latitude: 14.562909599624389,
    longitude: 121.03317570610837
  });
  const confirm = useCustomModal()
  const history = useHistory()

  const fetchExistingLocations = useCallback(
    async () => {
      try {
        setLoading(true)
        const user = await getUser()
        const locResult = await locationsService.getUserLocations(user?.client?.id || user?.user?.id, { confirmedOnly: false })
        setExistingLocations(locResult)
        setLoading(false)
      } catch (error) {
        setLoading(false)
      }
    },
    [],
  );

  useEffect(() => {
    fetchExistingLocations()
  }, []);

  const addLocation = useCallback(
    async (params) => {
      const user = await getUser()
      const res = await locationsService.addClientLocation(user?.client?.id || user?.user?.id, params)
      setBooking({
        ...booking,
        location: res
      })
    },
    [booking],
  );
  useEffect(() => {
    if (mapRef?.current) {
      mapRef?.current?.setCenter([marker?.longitude, marker?.latitude]);
    }
  }, [marker]);

  const [addMode, setAddMode] = useState(false);

  const checkSkipStep = useCallback(
    (s) => {
      if (skipStep) {
        setStep(skipStep)
        setSkipStep(null)
        history.replace(skipStep, { internal: true })
      } else {
        setStep(s)
        history.replace(s, { internal: true })
      }
    },
    [skipStep],
  );

  const matchCity = useCallback(
    async (location) => {
      try {
        const opId = await locationsService.mapLocationToOperationAreaId({
          latitude: location?.latitude,
          longitude: location?.longitude
        })
        return {
          ...location,
          operationAreaId: opId
        }
      } catch (error) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details, { error })
        return location
      }
    },
    [],
  );

  const checkCartStatus = useCallback(
    async ({ address }) => {
      // if (isCartEmpty || isCartPrefilled) {
      const mappedAddress = await matchCity(address)
      setBooking({
        ...booking,
        location: mappedAddress
      })

      setIsCartPrefilled(false)
      checkSkipStep(STEP_SCHEDULE)
      // } else {
      //   showCartMayChangeDialog({ address })
      // }
    },
    [booking, packages, services],
  );



  return (
    <>
      <PageHeader
        backStep={STEP_PERSONAL_DETAILS}
        currentStep={STEP_LOCATION}
        title={"Where should we deliver the service?"}
        subheader={!addMode ? "Select an existing location or add a new one." : "Enter your address in the box below or drag the map to your exact location. Use the tab button to proceed through the form"}
        loading={loading}
      >

        {addMode ? (
          <LocationEdit
            affirmLabel={"Add new location"}
            altLayout
            location={{
              latitude: 14.58,
              longitude: 121.0,
              newLocation: true
            }}
            isEditing
            requiresNewLocation
            forceRequireNewLocation
            onCancel={() => setAddMode(false)}
            onSelectConfirm={(a) => {
              console.log('index.jsx (37)onSelectConfirm', a)

            }}
            onSelectExistingConfirm={(a) => {
              console.log('index.jsx (41)onSelectExistingConfirm', a)

            }}
            onSelectEdit={(a) => {
              console.log('index.jsx (45)onSelectEdit', a)


            }}
            onUpdateAddress={async (a) => {
              console.log('index.jsx (49)onUpdateAddress', a)
              await addLocation(a)
              checkSkipStep(STEP_SCHEDULE)

            }}
          />
        ) : (
          <Grid container spacing={2}>
            {existingLocations?.length === 0 ?
              (
                <></>
              ) : (
                <Grid item xs={12} sm={6}>
                  <MapBox
                    draggable={false}
                    center={marker}
                    markerLocation={marker}
                    onMarkerDragEnd={(lnglat) => { }}
                    onRef={(ref) => {
                      mapRef.current = ref
                    }}
                    style={{ height: '50vh' }}
                  />
                </Grid>
              )}
            <Grid item xs={12} sm={6}>
              <Card
                classes={{
                  root: classes.cardRoot
                }}

              >
                <CardHeader
                  classes={{
                    root: classes.cardHeaderRoot,
                    action: classes.cardHeaderAction
                  }}
                  subheader="Tap to select from saved locations"
                  action={
                    <Button size="small"
                      onClick={() => {
                        trackEvent(`Create Booking Location Dialog - Add new location`)
                        setAddMode(true)
                      }}
                      color="primary" variant="contained">Add New Location</Button>
                  } />
                <CardContent style={{ height: '100%', display: 'flex', flex: 1 }}>
                  <List dense className={classes.locationList}>
                    {existingLocations?.map((loc, index) => (
                      <ListItem
                        selected={selectedLocation?.id === loc?.id}
                        button
                        onClick={() => {
                          setSelectedLocation(loc)
                          setBooking({
                            ...booking,
                            location: loc
                          })
                          setMarker({ longitude: loc?.longitude, latitude: loc?.latitude })
                        }}
                        alignItems='flex-start' disableGutters divider>
                        <ListItemIcon className={classes.addressIcon}>{parseAddressTypeToIcons(loc?.type_name)}</ListItemIcon>
                        <ListItemText
                          secondary={<div className={classes.secondaryLocation}>
                            {loc.name}
                            {loc.is_confirmed ? <></> :
                              <Typography variant="caption" color="error">unconfirmed</Typography>
                            }
                          </div>}
                          primary={<Typography
                            variant="body2"
                            className={classes.wrapper}
                            color={loc.is_confirmed ? 'textPrimary' : 'textSecondary'}>
                            {formatAddressObject(loc)}
                          </Typography>
                          }
                        />
                      </ListItem>
                    )
                    )}
                  </List>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
        <Toolbar>
          <div style={{ flexGrow: 1 }} />
          <Button disabled={!selectedLocation} onClick={async () => {
            trackEvent(`Create Booking Location screen - Continue`)
            checkCartStatus({ address: selectedLocation })
          }} color="primary" variant="contained" className={classes.button}>Continue</Button>
        </Toolbar>
      </PageHeader>
    </>
  )
}

const WrappedLocationScreen = (props) => {
  if (isAuthenticated()) {
    return <ABAltAuthenticatedLocationScreen {...props} />
  }
  return <LocationScreen {...props} />
}

export { WrappedLocationScreen as LocationScreen }
